<template>
  <div class="page-content centros-page">
    <div class="centros-wrapper">
      <div class="centros-card">
        <div v-if="cargando" class="centros-overlay">
          <div class="centros-overlay-inner">
            <svg class="centros-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="centros-spinner-track" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
              <path class="centros-spinner-head" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
            </svg>
            <p class="centros-overlay-text">Cargando centros de activación...</p>
          </div>
        </div>

        <div class="centros-header">
          <div>
            <p class="centros-title">Centros de activación</p>
            <p class="centros-subtitle">
              Administra país, retailer, número de tienda, display y datos de contacto de cada punto.
            </p>
          </div>

          <div class="centros-header-actions">
            <div class="centros-search">
              <input
                v-model="busqueda"
                type="text"
                placeholder="Buscar por store, retailer, país, # tienda, display, ciudad o estado…"
                class="centros-search-input"
              />
            </div>

            <button
              v-if="$canView && $canView('superadministrador', 'administrador')"
              type="button"
              class="ios-primary-button centros-add-btn"
              @click="abrirCrearCentro"
            >
              + Centro
            </button>
          </div>
        </div>

        <div class="centros-table-container">
          <div v-if="centrosFiltrados.length === 0 && !cargando" class="centros-empty">
            No se encontraron centros de activación.
          </div>

          <div v-else class="centros-table-wrapper">
            <table class="centros-table">
              <thead>
                <tr>
                  <th class="centros-th centros-th--nombre">Store</th>
                  <th class="centros-th">País</th>
                  <th class="centros-th">Retailer</th>
                  <th class="centros-th"># tienda</th>
                  <th class="centros-th">Display</th>
                  <th class="centros-th centros-th--contacto">Contacto</th>
                  <th class="centros-th centros-th--estado">Activo</th>
                  <th class="centros-th centros-th--acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(centro, index) in centrosFiltrados"
                  :key="centro.id_centro"
                  class="centros-row"
                  :class="index % 2 === 0 ? 'is-even' : 'is-odd'"
                >
                  <td class="centros-td centros-td--nombre">
                    <div class="centros-main-cell">
                      <div class="centros-avatar">
                        <span>{{ getInitials(centro.nombre) }}</span>
                      </div>
                      <div class="centros-main-text">
                        <p class="centros-nombre">{{ centro.nombre || 'Sin nombre' }}</p>
                        <p class="centros-direccion">
                          {{ construirUbicacionLigera(centro) || (centro.direccion || 'Sin dirección') }}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td class="centros-td"><span class="centros-text">{{ centro.pais || 'Mexico' }}</span></td>
                  <td class="centros-td"><span class="centros-text">{{ centro.retailer_nombre || '—' }}</span></td>
                  <td class="centros-td"><span class="centros-text">{{ centro.numero_tienda || '—' }}</span></td>
                  <td class="centros-td"><span class="centros-text">{{ centro.display || '—' }}</span></td>

                  <td class="centros-td centros-td--contacto">
                    <div class="centros-contacto">
                      <p class="centros-contacto-nombre">{{ centro.contacto_nombre || 'Sin contacto' }}</p>
                      <p class="centros-contacto-meta">
                        <span v-if="centro.contacto_telefono">📞 {{ centro.contacto_telefono }}</span>
                        <span v-if="centro.contacto_email" class="centros-contacto-email">✉️ {{ centro.contacto_email }}</span>
                      </p>
                    </div>
                  </td>

                  <td class="centros-td centros-td--estado">
                    <label class="centros-switch">
                      <input
                        type="checkbox"
                        class="centros-switch-input"
                        :checked="centro.activo == 1"
                        @change="toggleEstado(centro)"
                        :disabled="!($canView && $canView('superadministrador', 'administrador'))"
                      />
                      <span class="centros-switch-track"><span class="centros-switch-thumb"></span></span>
                    </label>
                  </td>

                  <td class="centros-td centros-td--acciones">
                    <div class="centros-actions">
                      <button type="button" class="centros-icon-btn" title="Ver detalles" @click="abrirDetalle(centro)">👁️</button>
                      <button
                        v-if="$canView && $canView('superadministrador', 'administrador')"
                        type="button"
                        class="centros-icon-btn centros-icon-btn--edit"
                        title="Editar centro"
                        @click="editar(centro)"
                      >
                        ✏️
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <FormularioCentroActivacion
      v-if="modalActivo"
      :centro="centroSeleccionado"
      @cerrar="cerrarModal"
      @guardado="recargar"
    />

    <DetalleCentroActivacion
      v-if="detalleActivo && centroDetalle"
      :centro="centroDetalle"
      @cerrar="cerrarDetalle"
    />
  </div>
</template>

<script>
import axios from 'axios';
import FormularioCentroActivacion from '@/components/almacen/centros/FormularioCentroActivacion.vue';
import DetalleCentroActivacion from '@/components/almacen/centros/DetalleCentroActivacion.vue';

export default {
  name: 'DashboardCentrosActivacion',
  components: {
    FormularioCentroActivacion,
    DetalleCentroActivacion,
  },
  data() {
    return {
      centros: [],
      cargando: false,
      busqueda: '',
      modalActivo: false,
      centroSeleccionado: null,
      detalleActivo: false,
      centroDetalle: null,
    };
  },
  computed: {
    centrosFiltrados() {
      const texto = this.busqueda.trim().toLowerCase();
      if (!texto) return this.centros;
      return this.centros.filter((c) => {
        const haystack = [
          c.nombre,
          c.pais,
          c.retailer_nombre,
          c.numero_tienda,
          c.display,
          c.ciudad,
          c.estado,
          c.direccion,
          c.contacto_nombre,
          c.contacto_email,
          c.contacto_telefono,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return haystack.includes(texto);
      });
    },
  },
  mounted() {
    this.cargarCentros();
  },
  methods: {
    getInitials(nombre) {
      if (!nombre) return 'C';
      const parts = nombre.split(' ').filter(Boolean);
      const first = parts[0]?.[0] || '';
      const second = parts[1]?.[0] || '';
      return (first + second).toUpperCase() || 'C';
    },
    construirUbicacionLigera(centro) {
      return [centro.ciudad, centro.estado].filter(Boolean).join(', ');
    },
    async cargarCentros() {
      this.cargando = true;
      try {
        const res = await axios.get('/api/almacen/centros/listar');
        this.centros = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error('Error al cargar centros:', err);
      } finally {
        this.cargando = false;
      }
    },
    abrirCrearCentro() {
      this.centroSeleccionado = null;
      this.modalActivo = true;
    },
    editar(centro) {
      this.centroSeleccionado = centro;
      this.modalActivo = true;
    },
    cerrarModal() {
      this.modalActivo = false;
      this.centroSeleccionado = null;
    },
    recargar() {
      this.cerrarModal();
      this.cargarCentros();
    },
    abrirDetalle(centro) {
      this.centroDetalle = centro;
      this.detalleActivo = true;
    },
    cerrarDetalle() {
      this.detalleActivo = false;
      this.centroDetalle = null;
    },
    async toggleEstado(centro) {
      const nuevoEstado = centro.activo == 1 ? 0 : 1;
      try {
        const res = await axios.post('/api/almacen/centros-activacion/cambiar-estado', {
          id_centro: centro.id_centro,
          activo: nuevoEstado,
        });

        if (res.data?.status === 'ok') {
          centro.activo = nuevoEstado;
        } else {
          console.error('No se pudo cambiar el estado');
        }
      } catch (error) {
        console.error('Error al cambiar el estado:', error);
      }
    },
  },
};
</script>

<style scoped>
.centros-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}
.centros-wrapper { width: 100%; max-width: 1320px; }
.centros-card {
  position: relative;
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.2rem;
  background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.35), rgba(15, 23, 42, 0.96));
  backdrop-filter: blur(24px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.9), 0 0 0 1px rgba(15, 23, 42, 0.85);
}
.centros-overlay {
  position: absolute; inset: 0; border-radius: 1.8rem; background: rgba(15, 23, 42, 0.78); backdrop-filter: blur(18px); z-index: 10; display: flex; align-items: center; justify-content: center;
}
.centros-overlay-inner { text-align: center; }
.centros-spinner { height: 32px; width: 32px; margin: 0 auto 0.5rem; }
.centros-spinner-track { opacity: 0.25; color: #e5e7eb; }
.centros-spinner-head { opacity: 0.9; color: #60a5fa; }
.centros-overlay-text { font-size: 0.82rem; color: #e5e7eb; }
.centros-header { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; margin-bottom: 1.1rem; }
.centros-title { font-size: 1.1rem; font-weight: 600; color: #e5e7eb; }
.centros-subtitle { font-size: 0.8rem; color: #94a3b8; }
.centros-header-actions { display: flex; align-items: center; gap: 0.75rem; }
.centros-search { min-width: 320px; }
.centros-search-input {
  width: 100%; border-radius: 999px; border: 1px solid rgba(148, 163, 184, 0.7); background: rgba(15, 23, 42, 0.94); padding: 0.42rem 0.85rem; font-size: 0.8rem; color: #e5e7eb; outline: none;
}
.centros-search-input::placeholder { color: #64748b; }
.centros-search-input:focus { border-color: #60a5fa; box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.7); }
.centros-add-btn { padding-inline: 0.95rem; font-size: 0.84rem; }
.centros-table-container {
  border-radius: 1.25rem; border: 1px solid rgba(148, 163, 184, 0.5); background: rgba(15, 23, 42, 0.92); padding: 0.6rem 0.7rem 0.55rem;
}
.centros-empty { font-size: 0.85rem; color: #e5e7eb; padding: 0.4rem 0.25rem; }
.centros-table-wrapper { width: 100%; overflow-x: auto; }
.centros-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; min-width: 1120px; }
.centros-th { text-align: left; padding: 0.35rem 0.45rem; color: #9ca3af; font-weight: 500; border-bottom: 1px solid rgba(148, 163, 184, 0.4); white-space: nowrap; }
.centros-th--nombre { min-width: 230px; }
.centros-th--contacto { min-width: 220px; }
.centros-th--estado, .centros-th--acciones { text-align: center; min-width: 84px; }
.centros-row { border-bottom: 1px solid rgba(30, 41, 59, 0.95); }
.centros-row.is-even { background: rgba(15, 23, 42, 0.9); }
.centros-row.is-odd { background: rgba(15, 23, 42, 0.96); }
.centros-td { padding: 0.48rem 0.45rem; vertical-align: middle; }
.centros-main-cell { display: flex; align-items: center; gap: 0.55rem; }
.centros-avatar {
  width: 28px; height: 28px; border-radius: 999px; background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.28), rgba(15, 23, 42, 1)); border: 1px solid rgba(148, 163, 184, 0.75); display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 600; color: #e5e7eb;
}
.centros-main-text { min-width: 0; }
.centros-nombre { font-size: 0.86rem; color: #e5e7eb; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.centros-direccion { font-size: 0.72rem; color: #9ca3af; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.centros-text { font-size: 0.8rem; color: #e5e7eb; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.centros-contacto { min-width: 0; }
.centros-contacto-nombre { font-size: 0.8rem; color: #e5e7eb; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.centros-contacto-meta { display: flex; flex-wrap: wrap; gap: 0.25rem 0.5rem; font-size: 0.7rem; color: #9ca3af; }
.centros-contacto-email { white-space: nowrap; }
.centros-td--estado { text-align: center; }
.centros-switch { position: relative; display: inline-flex; align-items: center; cursor: pointer; }
.centros-switch-input { display: none; }
.centros-switch-track {
  width: 36px; height: 18px; border-radius: 999px; background: rgba(30, 41, 59, 0.95); border: 1px solid rgba(148, 163, 184, 0.75); display: inline-flex; align-items: center; padding: 0 2px;
}
.centros-switch-thumb {
  width: 12px; height: 12px; border-radius: 999px; background: #94a3b8; transition: transform 0.16s ease, background 0.16s ease;
}
.centros-switch-input:checked + .centros-switch-track { background: rgba(59, 130, 246, 0.25); border-color: rgba(96, 165, 250, 0.95); }
.centros-switch-input:checked + .centros-switch-track .centros-switch-thumb { transform: translateX(18px); background: #60a5fa; }
.centros-td--acciones { text-align: center; }
.centros-actions { display: inline-flex; gap: 0.35rem; }
.centros-icon-btn {
  width: 30px; height: 30px; border-radius: 999px; border: 1px solid rgba(148, 163, 184, 0.7); background: rgba(15, 23, 42, 0.94); color: #e5e7eb; cursor: pointer;
}
.centros-icon-btn--edit { border-color: rgba(96, 165, 250, 0.7); }
.ios-primary-button,
.ios-ghost-button {
  border-radius: 999px; padding: 0.42rem 0.9rem; font-size: 0.78rem; border: 1px solid transparent; cursor: pointer;
}
.ios-primary-button {
  background: radial-gradient(circle at 0 0, rgba(129, 140, 248, 0.7), rgba(37, 99, 235, 1)); border-color: rgba(129, 140, 248, 0.9); color: #e5e7eb; box-shadow: 0 12px 26px rgba(37, 99, 235, 0.7);
}
@media (max-width: 900px) {
  .centros-header { flex-direction: column; align-items: stretch; }
  .centros-header-actions { flex-direction: column; align-items: stretch; }
  .centros-search { min-width: 0; width: 100%; }
}
</style>
